import { Component } from '@angular/core';

@Component({
  selector: 'app-peking-duck-meal-kit',
  imports: [],
  templateUrl: './peking-duck-meal-kit.html',
  styleUrl: './peking-duck-meal-kit.css',
})
export class PekingDuckMealKit {

}
